import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
}

const Heading2: React.FC<Heading2Props> = ({
  className = "py-8 lg:py-5",
  heading = "Todos nuestros hoteles",
  subHeading = "Encontra tu hotel ideal",
}) => {
  return (
    <div className={`mb-12 lg:mb-2 ${className}`}>
      <h2 className="text-4xl font-semibold">{heading}</h2>
      {subHeading && <span className="block mt-2 text-neutral-500">{subHeading}</span>}
    </div>
  );
};

export default Heading2;
